import React from "react";
import "./TTDRecommendationCard.scss";
import { pplaceholder } from "../../../Helpers/Images";
import { apiglobaltixMediaUrl } from "../../../Helpers/Config";
import { showPriceValue } from "../../../Helpers/SettingHelper";
import { TtdColorIcon } from "../../../../common/IconList/IconList";

const TTDRecommendationCard = (props) => {
  const { item, state, selectProduct } = props;
  const distance_ = item?.distance ?? "";

  return (
    <div
      className="ttd-recommendation-card"
      onClick={() => selectProduct(item)}
    >
      <div className="ttd-recommendation-card__img">
        <img
          src={
            item.product_thumbnail
              ? item.product_thumbnail.includes("https")
                ? item.product_thumbnail
                : apiglobaltixMediaUrl + item.product_thumbnail
              : pplaceholder
          }
          alt={item.products_name}
        />
      </div>
      <div className="ttd-recommendation-card__content">
        {distance_ && (
          <div className="ttd-recommendation-card__content__fRow">
            <div className="ttd-recommendation-card__content__fRow__col1">
              {parseFloat(distance_).toFixed("2")} km Distance from stay
            </div>
          </div>
        )}
        <div className="ttd-recommendation-card__content__title">
          {item.products_name}
        </div>
        {item.product_category_name !== "" &&
          item.product_category_name !== null && (
            <div className="ttd-recommendation-card__content__catName">
              <TtdColorIcon /> <span>{item.product_category_name}</span>
            </div>
          )}
        <div className="ttd-recommendation-card__content__sRow">
          <div className="ttd-recommendation-card__content__sRow__col1">
            {/* <span>{loadRatingNumber(item.classification_name)}</span>
            {loadRatingstar(item.classification_name, "hotel")} */}
          </div>
          <div className="ttd-recommendation-card__content__sRow__col2">
            <div className="ttd-recommendation-card__content__sRow__col2__label">
              Starts from
            </div>
            <div className="ttd-recommendation-card__content__sRow__col2__price">
              {showPriceValue(
                item.product_starting_price,
                state.currentCurrency,
                state.currencyRate
              )}
            </div>
          </div>
        </div>
        {/* <div
          onClick={() => viewHotelDetails(item.hotel_id)}
          className="ttd-recommendation-card__content__changeBtn"
        >
          {state.selectedHotelID === item.hotel_id
            ? "Change Room"
            : "Choose Room"}
          <AddIcon />
        </div> */}
      </div>
    </div>
  );
};

export default TTDRecommendationCard;
